import AJAXKlaviyoForm from '@/core/ajaxKlaviyoForm'
import type NewsletterForm from '@/components/newsletterForm'

/**
 * Wires a NewsletterForm component to an AJAXKlaviyoForm, connecting the
 * Klaviyo submission lifecycle to the form's UI state callbacks.
 */
export function wireNewsletterForm(formEl: HTMLElement, newsletterForm: NewsletterForm): AJAXKlaviyoForm {
  return new AJAXKlaviyoForm(formEl, {
    onSubmitStart: () => newsletterForm.onSubmitStart(),
    onSubmitFail: errors => newsletterForm.onSubmitFail(errors),
    onSubscribeSuccess: () => newsletterForm.onSubscribeSuccess(),
    onSubscribeFail: () => newsletterForm.onSubscribeFail()
  })
}
